import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { login } from "../../api";
import type { ILoginInput } from "../../types";

type IMutationResult = Awaited<ReturnType<typeof login>>;

export const useLoginMutation = () => {
  return useMutation<IMutationResult, AxiosError, ILoginInput>({
    mutationFn: login,
  });
};
